import React from "react";
import AnnouncementBar from "../../components/AnnouncementBar/AnnouncementBar";
import ChangePasswordForm from "../../components/UserAccountDetails/ChangePasswordForm";

const ChangePassowrd = () => {
  return (
    <>
      <AnnouncementBar />
      <ChangePasswordForm />
    </>
  );
};
export default ChangePassowrd;
